import { useApplicants } from './useApplicants'
import { useCreateAvatar } from './useCreateAvatar'
import { useDeleteUser } from './useDeleteUser'
import { useGetAddress } from './useGetAddress'
import { useGetUserById, useGetUsersListByRole } from './useGetUser'
import { useInviteApplicants } from './useInviteApplicants'
import * as UPR from './usePreferences'
import * as UP from './useProfile'
import { useUpdateActiveStatus } from './useUpdateActiveStatus'
import { useUpdateUserRole } from './useUpdateUserRole'

const user = {
  createAvatar: useCreateAvatar,
  getAddress: useGetAddress,
  preferences: {
    getMine: UPR.useGetPreferences,
    updateMine: UPR.useUpdatePreferences,
  },
  profile: {
    getScopes: UP.useGetMineScopes,
    getMine: UP.useGetMine,
    changeUserScope: UP.useChangeUserScope,
    createMine: UP.useCreateMine,
    editMine: UP.useEditMine,
    sendOTP: UP.useSendOTP,
    verifyOTP: UP.useVerifyOTP,
  },
  getById: useGetUserById,
  getListByRole: useGetUsersListByRole,
  updateActiveStatus: useUpdateActiveStatus,
  updateUserRole: useUpdateUserRole,
  deleteUser: useDeleteUser,
  applicants: useApplicants,
  inviteApplicants: useInviteApplicants,
}

export default user
